import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import type { SharedEntityInterface } from '../../../../../models/shared-study.interface';
import { StudyShareService } from '../../../../../services/study-share.service';

@Component({
  selector: 'app-share-revocation',
  templateUrl: './share-revocation.component.html',
  styleUrls: ['./share-revocation.component.scss']
})
export class ShareRevocationComponent implements OnInit {

  @Input() entityId: number;
  @Input() isStudy: boolean;
  sharedStudies: SharedEntityInterface[];
  loading = false;
  constructor(private readonly studyShareService: StudyShareService) {

  }

  ngOnInit(): void {
    this.loading = true;
    this.studyShareService.getEntityShares(this.entityId, this.isStudy).subscribe(shares => {
      this.sharedStudies = shares;
      this.loading = false;
    });
  }

  getShareTypeIcon(share: SharedEntityInterface) {
    if (share.shareTargetType.toString() === 'USER') {
      // Different icons based on user role
      // console.log(share);
      const role = share.userRole?.toUpperCase();
      // Check for INVITED first (before VET, since InvitedVet contains both)
      if (role?.includes('CLIENT')) {
        return 'pets';  // Icon for owner
      } else if (role?.includes('INVITED')) {
        return 'stethoscope_arrow';  // Icon for invited user
      } else if (role?.includes('ADMIN') || role?.includes('VET') || role?.includes('RADIOLOGIST')) {
        return 'stethoscope';  // Icon for vet/admin
      }

      return 'person';  // Default user icon
    }

    return 'local_hospital';  // Clinic icon
  }

  isSymbolIcon(share: SharedEntityInterface): boolean {
    const icon = this.getShareTypeIcon(share);
    // Return true for icons that are only available in Material Symbols
    return icon === 'stethoscope' || icon === 'stethoscope_arrow';
  }

  delete(share: SharedEntityInterface) {
    this.studyShareService.deleteShare(share.id, share.shareTargetType).subscribe(shareId => {
      this.sharedStudies = this.sharedStudies.filter(s=>s.id !== shareId);
    });
  }
}
